var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.325 11.25L3.375 9.625L1.4875 9.2375L1.7 7.4L0.5 6L1.7 4.6125L1.4875 2.775L3.375 2.3875L4.325 0.75L6 1.525L7.675 0.75L8.6375 2.3875L10.5125 2.775L10.3 4.6125L11.5 6L10.3 7.4L10.5125 9.2375L8.6375 9.625L7.675 11.25L6 10.475L4.325 11.25ZM4.6625 10.2625L6 9.7L7.375 10.2625L8.2125 9.0125L9.675 8.6375L9.525 7.15L10.5375 6L9.525 4.825L9.675 3.3375L8.2125 2.9875L7.35 1.7375L6 2.3L4.625 1.7375L3.7875 2.9875L2.325 3.3375L2.475 4.825L1.4625 6L2.475 7.15L2.325 8.6625L3.7875 9.0125L4.6625 10.2625ZM5.4625 7.6625L8.3 4.85L7.7375 4.3375L5.4625 6.5875L4.275 5.35L3.7 5.9125L5.4625 7.6625Z",
    fill: "#00BA6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.ebdc588a748381d6a56bcc5d7d9e2021.svg";
export { ForwardRef as ReactComponent };